"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
require("./SubNav.scss");
var _caratDown = _interopRequireDefault(require("../../images/carat-down.svg"));
var _caratUp = _interopRequireDefault(require("../../images/carat-up.svg"));
var _close = _interopRequireDefault(require("../../images/close.svg"));
var _lodash = require("lodash");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SiblingsMenu = _ref => {
  let {
    title,
    siblings = [],
    isOpen,
    isHidden,
    width,
    closeSiblingsWithEnter,
    onClick,
    onClose,
    Link
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const path = window?.location?.pathname;
  const [orderedSiblings, setOrderedSiblings] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    const equals = arr => {
      return (0, _lodash.orderBy)(siblings?.filter(d => arr.map(str => d?.pageName?.toLowerCase()?.indexOf(str) === 0).reduce((a, b) => a && b)), ["pageName"]);
    };
    const notEquals = arr => {
      return siblings?.filter(d => arr.map(str => d?.pageName?.toLowerCase()?.indexOf(str) !== 0).reduce((a, b) => a && b));
    };
    setOrderedSiblings([...equals(["overview"]), ...notEquals(["overview", "contact"]), ...equals(["contact"])]);
  }, [siblings]);
  if (siblings?.length <= 1) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-sub-nav__breadcrumbs__text ter-sub-nav__breadcrumbs__text--last"
    }, title);
  }
  const getTopPosition = () => {
    if (width > 600) {
      return "46px";
    } else if (width < 600 && window?.scrollY > 0 && isHidden) {
      return "48px";
    } else {
      return "108px";
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      margin: "auto 0",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-sub-nav__breadcrumbs__text ter-sub-nav__breadcrumbs__text--last",
    onClick: e => onClick(e),
    style: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement("img", {
    src: isOpen ? _caratUp.default : _caratDown.default,
    alt: "carat",
    className: "ter-sub-nav__siblings--carat-icon",
    style: {
      height: "24px",
      padding: "8px",
      cursor: "pointer"
    }
  })), /*#__PURE__*/_react.default.createElement("section", {
    id: "sub-nav-siblings",
    className: "ter-sub-nav__siblings",
    style: {
      display: isOpen ? "block" : "none",
      flexDirection: "column",
      flexWrap: "wrap",
      position: width > 600 ? "absolute" : "fixed",
      top: getTopPosition(),
      left: width < 600 && "0px",
      width: width > 600 ? "280px" : "100vw"
    }
  }, width < 600 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-sub-nav__close-btn",
    onClick: e => onClose(e),
    onKeyDown: e => closeSiblingsWithEnter(e),
    style: {
      backgroundColor: "#0063A3",
      height: "44px",
      width: "44px",
      position: "absolute",
      right: "0",
      top: "0",
      display: isOpen ? "block" : "none"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    tabIndex: "0",
    src: _close.default,
    alt: "close",
    className: "ter-sub-nav__close-btn--icon",
    style: {
      height: "100%",
      width: "100%",
      padding: "15px",
      cursor: "pointer",
      margin: "auto",
      display: isOpen ? "block" : "none"
    }
  })), /*#__PURE__*/_react.default.createElement("ul", {
    className: "ter-sub-nav__siblings__list"
  }, orderedSiblings && orderedSiblings?.map((sibling, i) => {
    const active = sibling.slug === path;
    return sibling.slug && !active ? /*#__PURE__*/_react.default.createElement("li", {
      key: `sibling-item-${i}`,
      className: "ter-sub-nav__siblings__list__list-item"
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      to: sibling.slug,
      tabIndex: mouse ? "" : "0",
      key: sibling.pageName,
      className: mouse ? "ter-sub-nav__siblings__link" : "ter-sub-nav__siblings__link tabFocus",
      target: sibling.typeName === "ContentfulExternalLink" ? "_blank" : "_self"
      // id={formatID(`${sibling.pageName}-sub-nav-link`)}
      ,
      Link: Link
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: `${active && "ter-sub-nav__siblings__text--active--dropdown"} ter-sub-nav__siblings__text--dropdown`
    }, sibling.pageName))) : /*#__PURE__*/_react.default.createElement("li", {
      key: `sibling-item-${i}`,
      className: "ter-sub-nav__siblings__list__list-item"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-sub-nav__siblings__text"
    }, sibling.pageName));
  }))));
};
var _default = SiblingsMenu;
exports.default = _default;